import { CommonResponse, get } from './common.ts'

/**
 * (01)
 * 과목 정보 조회
 */

// Get /subjects/{majorId}
interface GetSubjectsRequest {
  majorId: string
}
interface GetSubjectsResponse {
  id: string
  name: string
  schoolId: string
  majorId: string
}

export const getSubjects = async (
  request: GetSubjectsRequest,
): Promise<CommonResponse<GetSubjectsResponse>> => {
  return await get(`/subjects/${request.majorId}`)
}
